'use client'

import dynamic from 'next/dynamic'
import type { ReactNode } from 'react'
import { useFirstUserScroll } from './hooks/useFirstUserScroll'

const Arrow = dynamic(() => import('./Arrow/Arrow').then((mod) => mod.Arrow), {
	ssr: false,
})

export function Scroll(): ReactNode {
	const firstUserScroll = useFirstUserScroll()

	if (!firstUserScroll) {
		return null
	}
	return <Arrow />
}
